export default __webpack_public_path__ + "static/nodegh-aadac15ecfa8b61c7c7ae31422264fa6.webm";